module.exports = __webpack_public_path__ + "static/media/logout.421c8a75.svg";